import React, { useState } from "react";
import { Box, Button, CircularProgress, Stack } from "@mui/material";
import SearchResultGrid from "../searchResultGrid/searchResultGrid";
import apiClient from "../../axiosClient";
// Custom types and defs
import templateColumnDef from "./colDef/templateConfig";
import Template from "./interface/template";
import HuntGroup from "./interface/huntGroup";
import AddTemplateModal, { NewTemplateRequest } from "./modal/addTemplate";
import { apiCallWrapper } from "../../utils/commonUtils";

interface TemplateConfigComponentProp {
	loading: boolean,
	templates: Template[],
	huntGroups: HuntGroup[],
	refresh: () => void
}

const TemplateConfig: React.FC<TemplateConfigComponentProp> = ({ loading, templates, huntGroups, refresh }) => {
	const [openAddTemplateModal, setAddTemplateModalVisibility] = useState<boolean>(false);

	const handleSubmit = async (newTemplateRequest: NewTemplateRequest) => {
		const payload = {
			template_name: newTemplateRequest.templateName,
			schedule_template_number: newTemplateRequest.templateNumber,
			hunt_group_id: newTemplateRequest.selectedHuntGroup,
			agency_name: newTemplateRequest.selectedAgency,
			client_name: newTemplateRequest.clientName || undefined,
			field_mappings: [
				{
					"column_index": 0,
					"column_name": "case_id",
					"required": true
				},
				{
					"column_index": 1,
					"column_name": "client_reference_id",
					"required": true
				},
				{
					"column_index": 2,
					"column_name": "client_name",
					"required": true
				},
				{
					"column_index": 3,
					"column_name": "agency_name",
					"required": true
				},
				{
					"column_index": 4,
					"column_name": "Customer Contact",
					"required": true
				},
				{
					"column_index": 5,
					"column_name": "alternate_number_1",
					"required": false
				},
				{
					"column_index": 6,
					"column_name": "alternate_number_2",
					"required": false
				},
				{
					"column_index": 7,
					"column_name": "alternate_number_3",
					"required": false
				},
				{
					"column_index": 8,
					"column_name": "alternate_number_4",
					"required": false
				},
				{
					"column_index": 9,
					"column_name": "alternate_number_5",
					"required": false
				},
				{
					"column_index": 10,
					"column_name": "alternate_number_6",
					"required": false
				},
				{
					"column_index": 11,
					"column_name": "alternate_number_7",
					"required": false
				},
				{
					"column_index": 12,
					"column_name": "alternate_number_8",
					"required": false
				},
				{
					"column_index": 13,
					"column_name": "alternate_number_9",
					"required": false
				},
				{
					"column_index": 14,
					"column_name": "alternate_number_10",
					"required": false
				},
				{
					"column_index": 15,
					"column_name": "pdb_id",
					"is_system_injected": true,
					"required": true
				}
			],
		};

		const response = await apiCallWrapper(() => apiClient.post(`/api/v1/tcn_config/tcn_template`, payload));
		if (response && (response.status === 200 || response.status === 201)) {
			alert("Template added successfully");
			refresh();
			setAddTemplateModalVisibility(false);
		}
	};

	return (
		<Box sx={{ margin: '10px', display: 'flex', flexDirection: 'column' }}>
			<Stack
				direction="row"
				spacing={2}
				justifyContent="flex-end"
				sx={{ mb: 2 }}
			>
				<Button variant="contained" onClick={() => setAddTemplateModalVisibility(true)}>Add Template</Button>
			</Stack>

			{loading ? (
				<Box sx={{ display: 'flex', justifyContent: 'center', p: 5 }}>
					<CircularProgress />
				</Box>
			) : (
				<SearchResultGrid
					columns={templateColumnDef}
					results={templates}
					rowCount={templates.length}
					onSelectRow={() => { }}
					getRowId={(row: Template) => row.id}
					disableFilter={false}
					disableSorting={false}
				/>
			)}

			{openAddTemplateModal ? <AddTemplateModal open={openAddTemplateModal} onSubmit={handleSubmit} onClose={() => setAddTemplateModalVisibility(false)} huntGroups={huntGroups} /> : null}
		</Box>
	);
};

export default TemplateConfig;